import React from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  makeSelectCurrentUser,
  makeSelectGlobalProperty,
} from '../../App/selectors';
import { updateEntity as updateKaiEntity } from '../../Kai/actions';
import { canViewKai } from '../../Kai/canViewKai';

const FAB_SIZE = 60;
const FAB_INSET = 24;

/**
 * Fixed kAI launcher shown only on Native Analytics. Portaled to document.body
 * so it stays pinned to the viewport bottom-right while the page scrolls.
 * Hidden while the kAI drawer is open.
 */
const KaiFab = () => {
  const dispatch = useDispatch();
  const user = useSelector(makeSelectCurrentUser());
  const appSettings = useSelector(makeSelectGlobalProperty('appSettings'));
  const isDrawerOpen = useSelector(s => s.kai?.isDrawerOpen || false);
  const visible = canViewKai(user, appSettings);

  if (!visible || isDrawerOpen || typeof document === 'undefined') return null;

  return createPortal(
    <button
      type="button"
      aria-label="Open kAI"
      title="kAI"
      className="fixed flex items-center justify-center rounded-full bg-primary text-white shadow-md"
      style={{
        bottom: FAB_INSET,
        right: FAB_INSET,
        width: FAB_SIZE,
        height: FAB_SIZE,
        zIndex: 9999,
      }}
      onClick={() => dispatch(updateKaiEntity({ isDrawerOpen: true }))}
    >
      <i className="kt-sparkles text-3xl" />
    </button>,
    document.body,
  );
};

export default KaiFab;
